/**
 * Section: Collections Show (slider layout)
 * Swiper is loaded through window.loadThemeSwiper() once the section nears the viewport.
 */

(function () {
  'use strict';

  if (customElements.get('collections-show-slider')) return;

  class CollectionsShowSlider extends HTMLElement {
    connectedCallback() {
      const whenVisible = window.theme?.whenVisible;

      if (whenVisible && this.dataset.visibilityInitialized !== 'true') {
        this.observer = whenVisible(this, () => this.init());
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    init() {
      const swiperElement = this.querySelector('.collections-show__swiper');
      if (!swiperElement || this.swiper || !window.loadThemeSwiper) return;

      window.loadThemeSwiper().then(() => {
        if (!this.isConnected || this.swiper) return;
        this.swiper = new window.Swiper(swiperElement, this.options());
      }).catch((error) => {
        console.warn('Swiper failed to load for CollectionsShow:', error);
      });
    }

    options() {
      const data = this.dataset;
      const slidesDesktop = parseInt(data.slidesDesktop, 10) || 3;
      const slidesTablet = parseInt(data.slidesTablet, 10) || 2;
      const slidesMobile = parseInt(data.slidesMobile, 10) || 1;
      const gap = parseInt(data.gap, 10) || 24;
      const prevEl = this.querySelector('.collections-show__nav-btn--prev');
      const nextEl = this.querySelector('.collections-show__nav-btn--next');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = data.autoplay === 'true' && !reducedMotion;

      return {
        slidesPerView: slidesMobile,
        spaceBetween: Math.min(gap, 16),
        speed: reducedMotion ? 0 : 500,
        // Lock the slider (and hide arrows via .swiper-button-lock) when all cards fit
        watchOverflow: true,
        // Slides are <a> links: role="group" is invalid on them and the "1 / 3" label would replace the link text
        a11y: { slideRole: '', slideLabelMessage: '' },
        rewind: autoplay,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl,
          disabledClass: 'collections-show__nav-btn--disabled',
        } : false,
        autoplay: autoplay ? {
          delay: parseInt(data.autoplayDelay, 10) || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        breakpoints: {
          750: { slidesPerView: slidesTablet, spaceBetween: gap },
          990: { slidesPerView: slidesDesktop, spaceBetween: gap },
        },
      };
    }
  }

  customElements.define('collections-show-slider', CollectionsShowSlider);
})();
